import React from 'react';
import { Navigate } from 'react-router-dom';

import { FacilityDetails } from './FacilityDetails';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';

export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/settings/implementations" />;
    }}
  >
    <FacilityDetails />
  </RouteErrorBoundary>
);
